import { safeErr } from '../App';
import React, { useState, useEffect } from 'react';
import api from '../api';

const DEFAULT = {
  sender_name:'Ratheesh', sender_title:'Director', sender_company:'Pickzy Interactive',
  sender_phone:'+91 44 4501 4466', sender_website:'www.pickzy.com',
  sending_email:'macratheesh@gmail.com', forward_to:'macratheesh@gmail.com',
  email_signature:'',
  product_desc:'We build custom software products for startups — from MVPs to full-scale platforms.',
  followup_delay:'3', max_followups:'3',
  auto_followup:true, auto_forward:false, pause_on_reply:true, auto_close:true,
  apollo_api_key:'', product_hunt_api_key:'',
  adzuna_app_id:'', adzuna_app_key:'', hunter_api_key:'',
};

export default function Settings({ showToast }) {
  const [f, setF]          = useState(null);
  const [saving, setSave]  = useState(false);
  const [preview, setPrev] = useState(false);

  // Gmail account manager state
  const [gmailAccounts,  setGmailAccts]   = useState([]);
  const [testing,        setTesting]      = useState(false);
  const [testResult,     setTestResult]   = useState(null);
  const [showManualAdd,  setShowManualAdd]= useState(false);
  const [manualEmail,    setManualEmail]  = useState('');
  const [manualToken,    setManualToken]  = useState('');
  const [manualName,     setManualName]   = useState('');

  const loadGmailAccounts = () => {
    api.get('/gmail/accounts').then(r => setGmailAccts(r.data)).catch(()=>{});
  };

  useEffect(() => {
    api.get('/settings')
      .then(r => setF({...DEFAULT,...r.data}))
      .catch(() => setF(DEFAULT));
    loadGmailAccounts();
  }, []);

  const set  = (k,v) => setF(p=>({...p,[k]:v}));
  const save = async () => {
    setSave(true);
    try {
      await api.post('/settings', f);
      showToast('✓ Settings saved successfully!');
    } catch(e) {
      showToast(e.response?.data?.detail||'Failed to save','error');
    } finally { setSave(false); }
  };

  const testConnection = async () => {
    setTesting(true); setTestResult(null);
    try {
      const r = await api.post('/gmail/test');
      setTestResult(r.data);
    } catch(e) {
      setTestResult({ ok:false, error: safeErr(e, 'Connection failed') });
    } finally { setTesting(false); }
  };

  const switchAccount = async (email) => {
    try {
      await api.post('/gmail/accounts/switch', { email });
      showToast(`✓ Switched to ${email}`);
      loadGmailAccounts();
      // Also refresh settings to show new email
      api.get('/settings').then(r => setF({...DEFAULT,...r.data}));
    } catch(e) { showToast('Switch failed', 'error'); }
  };

  const removeAccount = async (email) => {
    if (!window.confirm(`Remove ${email}?`)) return;
    try {
      await api.delete(`/gmail/accounts/${encodeURIComponent(email)}`);
      showToast('Account removed');
      loadGmailAccounts();
    } catch(e) { showToast('Remove failed','error'); }
  };

  const connectNewAccount = async () => {
    try {
      const r = await api.get('/gmail/oauth/start');
      const url = r.data.url;
      // Open OAuth in popup window
      const popup = window.open(url, 'gmail_oauth',
        'width=520,height=620,scrollbars=yes,resizable=yes');
      // Listen for callback message
      const handler = (e) => {
        if (e.data?.type === 'gmail_connected') {
          window.removeEventListener('message', handler);
          showToast(`✓ ${e.data.email} connected!`);
          loadGmailAccounts();
          if (popup) popup.close();
        }
      };
      window.addEventListener('message', handler);
      // Fallback — poll if popup closed without message
      const poll = setInterval(() => {
        if (popup?.closed) {
          clearInterval(poll);
          loadGmailAccounts();
        }
      }, 1000);
    } catch(e) { showToast('Could not start OAuth', 'error'); }
  };

  const addManualAccount = async () => {
    try {
      await api.post('/gmail/accounts/add-manual', {
        email: manualEmail, refresh_token: manualToken, name: manualName
      });
      showToast(`✓ ${manualEmail} added`);
      setShowManualAdd(false);
      setManualEmail(''); setManualToken(''); setManualName('');
      loadGmailAccounts();
    } catch(e) { showToast(e.response?.data?.detail||'Failed to add','error'); }
  };

  if (!f) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',padding:48}}><div className="spinner spinner-lg"/></div>;

  const Toggle = ({k}) => (
    <label className="toggle">
      <input type="checkbox" checked={!!f[k]} onChange={e=>set(k,e.target.checked)}/>
      <span className="toggle-slider"/>
    </label>
  );

  // Live signature preview
  const sigPreview = f.email_signature?.trim()
    ? f.email_signature
    : `${f.sender_name}\n${f.sender_title}, ${f.sender_company}\n${f.sending_email}  |  ${f.sender_phone}\n${f.sender_website}`;

  return (
    <div style={{maxWidth:760}}>

      {/* ── Email Account ── */}
      <div className="card" style={{marginBottom:14}}>
        <div className="card-header"><span className="card-title">Email account</span></div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group"><label className="form-label">Your name (sender)</label>
              <input className="form-input" value={f.sender_name||''} onChange={e=>set('sender_name',e.target.value)}/></div>
            <div className="form-group"><label className="form-label">Title / role</label>
              <input className="form-input" value={f.sender_title||''} onChange={e=>set('sender_title',e.target.value)} placeholder="Director"/></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Company name</label>
              <input className="form-input" value={f.sender_company||''} onChange={e=>set('sender_company',e.target.value)}/></div>
            <div className="form-group"><label className="form-label">Sending email</label>
              <input className="form-input" value={f.sending_email||''} onChange={e=>set('sending_email',e.target.value)}/></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Phone</label>
              <input className="form-input" value={f.sender_phone||''} onChange={e=>set('sender_phone',e.target.value)}/></div>
            <div className="form-group"><label className="form-label">Website</label>
              <input className="form-input" value={f.sender_website||''} onChange={e=>set('sender_website',e.target.value)}/></div>
          </div>
        </div>
      </div>

      {/* ── Email Signature ── */}
      <div className="card" style={{marginBottom:14}}>
        <div className="card-header">
          <span className="card-title">Email signature</span>
          <button className="btn btn-sm" onClick={()=>setPrev(p=>!p)}>
            {preview?'Hide preview':'Preview'}
          </button>
        </div>
        <div className="card-body">
          <div className="form-group">
            <label className="form-label">
              Custom signature
              <span style={{fontWeight:400,color:'var(--text-2)',marginLeft:4}}>(leave blank to use auto-generated from your details above)</span>
            </label>
            <textarea className="form-textarea" value={f.email_signature||''} onChange={e=>set('email_signature',e.target.value)}
              placeholder="Leave blank to auto-generate from your name/title/company/phone/website above"
              style={{minHeight:72,fontFamily:'monospace',fontSize:12}}/>
          </div>

          {preview && (
            <div style={{background:'var(--surface2)',border:'1px solid var(--border)',
              borderRadius:'var(--r-sm)',padding:'10px 14px',marginTop:4}}>
              <div style={{fontSize:10,fontWeight:600,color:'var(--text-3)',marginBottom:6,
                textTransform:'uppercase',letterSpacing:'.05em'}}>Preview</div>
              <pre style={{fontSize:12,fontFamily:'inherit',whiteSpace:'pre-wrap',color:'var(--text-2)',
                borderTop:'1px solid var(--border)',paddingTop:8,lineHeight:1.7,margin:0}}>
                {sigPreview}
              </pre>
              <div style={{fontSize:10,color:'var(--text-3)',marginTop:8,borderTop:'1px solid var(--border)',paddingTop:6}}>
                Pickzy Interactive, JVL Plaza, Anna Salai, Chennai 600 018, India<br/>
                To unsubscribe: [auto-generated link]
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── AI & Email ── */}
      <div className="card" style={{marginBottom:14}}>
        <div className="card-header"><span className="card-title">AI & email settings</span></div>
        <div className="card-body">
          <div className="form-group">
            <label className="form-label">
              Product / service description
              <span style={{fontWeight:400,color:'var(--text-2)',marginLeft:4}}>(AI uses this to write all outreach emails)</span>
            </label>
            <textarea className="form-textarea" value={f.product_desc||''} onChange={e=>set('product_desc',e.target.value)}
              style={{minHeight:80,lineHeight:1.7}}/>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Follow-up delay</label>
              <select className="form-select" value={f.followup_delay||'3'} onChange={e=>set('followup_delay',e.target.value)}>
                {[['1','1 day'],['2','2 days'],['3','3 days'],['5','5 days'],['7','1 week']].map(([v,l])=>(
                  <option key={v} value={v}>{l}</option>))}
              </select>
            </div>
            <div className="form-group"><label className="form-label">Max follow-ups per lead</label>
              <select className="form-select" value={f.max_followups||'3'} onChange={e=>set('max_followups',e.target.value)}>
                {['1','2','3','4'].map(n=><option key={n} value={n}>{n} follow-ups</option>)}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* ── API Keys ── */}
      <div className="card" style={{marginBottom:14}}>
        <div className="card-header"><span className="card-title">Lead source API keys</span></div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">
                Apollo.io API key
                <span style={{fontWeight:400,color:'var(--text-2)',marginLeft:4}}>(used by Generate Leads → Apollo.io)</span>
              </label>
              <input className="form-input" type="password" value={f.apollo_api_key||''}
                onChange={e=>set('apollo_api_key',e.target.value)} placeholder="Paste your Apollo.io API key"/>
            </div>
            <div className="form-group">
              <label className="form-label">
                Product Hunt API key
                <span style={{fontWeight:400,color:'var(--text-2)',marginLeft:4}}>(used by Generate Leads → Product Hunt)</span>
              </label>
              <input className="form-input" type="password" value={f.product_hunt_api_key||''}
                onChange={e=>set('product_hunt_api_key',e.target.value)} placeholder="Paste your Product Hunt developer token"/>
            </div>
          </div>
          <div className="form-row" style={{marginTop:14}}>
            <div className="form-group">
              <label className="form-label">
                Adzuna app ID
                <span style={{fontWeight:400,color:'var(--text-2)',marginLeft:4}}>(used by Generate Leads → Job Postings)</span>
              </label>
              <input className="form-input" type="password" value={f.adzuna_app_id||''}
                onChange={e=>set('adzuna_app_id',e.target.value)} placeholder="Paste your Adzuna app ID"/>
            </div>
            <div className="form-group">
              <label className="form-label">
                Adzuna app key
                <span style={{fontWeight:400,color:'var(--text-2)',marginLeft:4}}>(used by Generate Leads → Job Postings)</span>
              </label>
              <input className="form-input" type="password" value={f.adzuna_app_key||''}
                onChange={e=>set('adzuna_app_key',e.target.value)} placeholder="Paste your Adzuna app key"/>
            </div>
          </div>
          <div className="form-group" style={{marginTop:14}}>
            <label className="form-label">
              Hunter.io API key
              <span style={{fontWeight:400,color:'var(--text-2)',marginLeft:4}}>(used by Generate Leads → Job Postings, to find a contact at each company)</span>
            </label>
            <input className="form-input" type="password" value={f.hunter_api_key||''}
              onChange={e=>set('hunter_api_key',e.target.value)} placeholder="Paste your Hunter.io API key"/>
          </div>
          <div style={{fontSize:11,color:'var(--text-2)',lineHeight:1.6,marginTop:10}}>
            Apollo's People Search API requires a paid plan — a free-tier key will return a permissions
            error and fall back to demo data. Get a Product Hunt token from{' '}
            <a href="https://www.producthunt.com/v2/oauth/applications" target="_blank" rel="noreferrer">
              producthunt.com/v2/oauth/applications
            </a>. Get a free Adzuna app ID + key from{' '}
            <a href="https://developer.adzuna.com/" target="_blank" rel="noreferrer">
              developer.adzuna.com
            </a>. Get a free Hunter.io API key (50 lookups/mo, no card required) from{' '}
            <a href="https://hunter.io/api-keys" target="_blank" rel="noreferrer">
              hunter.io/api-keys
            </a>.
          </div>
        </div>
      </div>

      {/* ── Automation ── */}
      <div className="card" style={{marginBottom:14}}>
        <div className="card-header"><span className="card-title">Automation controls</span></div>
        <div className="card-body">
          {[
            ['auto_followup',  'Auto-send follow-up emails',     'Sends follow-ups automatically on schedule — no manual action needed'],
            ['pause_on_reply', 'Pause sequence when lead replies','Stops all pending follow-ups the moment a lead responds'],
            ['auto_close',     'Auto-close after max follow-ups', 'Marks lead as closed if no reply after all follow-ups sent'],
            ['auto_forward',   'Forward replies to personal email','Forwarding is currently on hold — activate when ready'],
          ].map(([k,l,d])=>(
            <div key={k} style={{display:'flex',justifyContent:'space-between',
              alignItems:'center',padding:'12px 0',borderBottom:'1px solid var(--border)'}}>
              <div>
                <div style={{fontSize:13,fontWeight:500}}>{l}</div>
                <div style={{fontSize:11,color:'var(--text-2)',marginTop:2}}>{d}</div>
              </div>
              <Toggle k={k}/>
            </div>
          ))}
        </div>
      </div>


      {/* ── Gmail Account Manager ── */}
      <div className="card" style={{marginBottom:14}}>
        <div className="card-header">
          <span className="card-title">📧 Connected Gmail accounts</span>
          <div style={{display:'flex',gap:8}}>
            <button className="btn btn-sm" onClick={testConnection} disabled={testing}>
              {testing ? <><span className="spinner spinner-sm"/>Testing…</> : '⚡ Test connection'}
            </button>
            <button className="btn btn-primary btn-sm" onClick={connectNewAccount}>
              + Connect account
            </button>
          </div>
        </div>
        <div className="card-body">

          {testResult && (
            <div className={`alert ${testResult.ok?'alert-success':'alert-error'}`} style={{marginBottom:12}}>
              {testResult.ok
                ? `✓ Connected as ${testResult.email} — ${testResult.messages?.toLocaleString()} messages in mailbox`
                : `✗ Connection failed: ${testResult.error}`}
            </div>
          )}

          {gmailAccounts.length === 0 ? (
            <div className="empty-state" style={{padding:24}}>
              <div className="empty-desc">No Gmail accounts connected yet</div>
            </div>
          ) : (
            <div style={{display:'flex',flexDirection:'column',gap:8}}>
              {gmailAccounts.map(acc => (
                <div key={acc.email} style={{
                  display:'flex',alignItems:'center',gap:12,padding:'12px 14px',
                  border:`2px solid ${acc.active?'var(--blue)':'var(--border)'}`,
                  borderRadius:'var(--r-lg)',
                  background:acc.active?'var(--blue-bg)':'var(--surface)',
                  transition:'all .12s',
                }}>
                  {/* Avatar */}
                  <div style={{
                    width:40,height:40,borderRadius:'50%',flexShrink:0,
                    background:acc.active?'var(--blue)':'var(--surface2)',
                    color:acc.active?'#fff':'var(--text-2)',
                    display:'flex',alignItems:'center',justifyContent:'center',
                    fontSize:16,fontWeight:700,
                  }}>
                    {acc.name?.charAt(0)?.toUpperCase()||acc.email?.charAt(0)?.toUpperCase()}
                  </div>

                  {/* Info */}
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:'flex',alignItems:'center',gap:7}}>
                      <span style={{fontWeight:600,fontSize:13}}>{acc.name}</span>
                      {acc.active && <span className="pill pill-blue" style={{fontSize:10}}>● Active sender</span>}
                    </div>
                    <div style={{fontSize:12,color:'var(--text-2)',marginTop:1}}>{acc.email}</div>
                    {acc.added_at && acc.added_at !== 'from .env' &&
                      <div style={{fontSize:11,color:'var(--text-3)',marginTop:1}}>Connected {acc.added_at}</div>}
                  </div>

                  {/* Actions */}
                  <div style={{display:'flex',gap:7,flexShrink:0}}>
                    {!acc.active && (
                      <button className="btn btn-primary btn-sm"
                        onClick={()=>switchAccount(acc.email)}>
                        Switch to this
                      </button>
                    )}
                    {gmailAccounts.length > 1 && (
                      <button className="btn btn-danger btn-sm"
                        onClick={()=>removeAccount(acc.email)}>
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Manual add form */}
          {showManualAdd && (
            <div style={{marginTop:14,padding:'14px',background:'var(--surface2)',
              border:'1px solid var(--border)',borderRadius:'var(--r-lg)'}}>
              <div style={{fontWeight:600,fontSize:13,marginBottom:10}}>
                Add account manually (via refresh token)
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Gmail address</label>
                  <input className="form-input" value={manualEmail}
                    onChange={e=>setManualEmail(e.target.value)}
                    placeholder="michael@pickzy.com"/>
                </div>
                <div className="form-group">
                  <label className="form-label">Display name</label>
                  <input className="form-input" value={manualName}
                    onChange={e=>setManualName(e.target.value)}
                    placeholder="Michael"/>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Refresh token</label>
                <input className="form-input" type="password" value={manualToken}
                  onChange={e=>setManualToken(e.target.value)}
                  placeholder="1//0g…"/>
                <div style={{fontSize:11,color:'var(--text-2)',marginTop:4}}>
                  Get this from Google OAuth Playground or your existing .env file
                </div>
              </div>
              <div style={{display:'flex',gap:8,marginTop:6}}>
                <button className="btn btn-primary btn-sm" onClick={addManualAccount}
                  disabled={!manualEmail||!manualToken}>
                  Add account
                </button>
                <button className="btn btn-sm" onClick={()=>setShowManualAdd(false)}>
                  Cancel
                </button>
              </div>
            </div>
          )}

          <div style={{marginTop:12,padding:'10px 12px',background:'var(--surface2)',
            borderRadius:'var(--r-sm)',fontSize:12,color:'var(--text-2)',lineHeight:1.6}}>
            <strong style={{color:'var(--text)'}}>How to add michael@pickzy.com:</strong>
            <ol style={{marginTop:5,marginLeft:16,display:'flex',flexDirection:'column',gap:3}}>
              <li>Click <strong>+ Connect account</strong> above — this opens Google sign-in</li>
              <li>Sign in with michael@pickzy.com</li>
              <li>Grant the Gmail permissions</li>
              <li>Click <strong>Switch to this</strong> to make it the active sender</li>
            </ol>
            <div style={{marginTop:6,color:'var(--text-3)'}}>
              Or use <strong>Add account manually</strong> if you already have the refresh token from a previous OAuth setup.
            </div>
          </div>
        </div>
      </div>

      {/* ── Compliance note ── */}
      <div className="alert alert-info" style={{marginBottom:14,fontSize:12}}>
        <div>
          <strong>CAN-SPAM &amp; GDPR compliance</strong> — Every email automatically includes your company address and a one-click unsubscribe link. Unsubscribed leads are immediately removed from all sequences.
        </div>
      </div>

      <div style={{display:'flex',gap:10}}>
        <button className="btn btn-primary" disabled={saving} onClick={save}>
          {saving?<><span className="spinner spinner-sm"/>Saving…</>:'✓ Save settings'}
        </button>
        <button className="btn" onClick={()=>api.get('/settings').then(r=>setF({...DEFAULT,...r.data}))}>
          Reset to saved
        </button>
      </div>
    </div>
  );
}
